/**
 * Default style: OpenFreeMap Liberty — a full OSM-based style with 3D buildings,
 * roads, labels, terrain shading, and sprites. No API key required.
 *
 * Loaded from URL at startup. Falls back to a minimal inline style if fetch fails.
 */

export const DEFAULT_STYLE_URL = "https://tiles.openfreemap.org/styles/liberty";

/** Minimal fallback if the remote style can't be loaded */
export const FALLBACK_STYLE = {
  version: 8 as const,
  name: "Fallback — Add a source to get started",
  center: [8.55, 47.37] as [number, number],
  zoom: 14,
  pitch: 45,
  bearing: -17,
  sources: {},
  layers: [
    {
      id: "background",
      type: "background" as const,
      paint: { "background-color": "#f0f0f0" },
    },
  ],
};

/**
 * Fetches the default style. Returns the remote style with editor defaults
 * injected (pitch, center on a city with 3D buildings).
 */
export async function loadDefaultStyle(): Promise<Record<string, unknown>> {
  try {
    const res = await fetch(DEFAULT_STYLE_URL);
    if (!res.ok) throw new Error(`${res.status}`);
    const style = (await res.json()) as Record<string, unknown>;

    // Override initial view to show 3D buildings (Zurich old town)
    style.name = style.name ?? "OpenFreeMap Liberty";
    style.center = [8.541, 47.376];
    style.zoom = 15.5;
    style.pitch = 50;
    style.bearing = -17;

    return style;
  } catch {
    return FALLBACK_STYLE as unknown as Record<string, unknown>;
  }
}
